"use client"

import { useState, useEffect } from 'react';
import { Palette, Shuffle, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const __ = (key: string) => key;

const ColorRandom = () => {

    const [color, setColor] = useState('rgba(210,211,213,1)');
    const [myColors, setMyColors] = useState([]);

    useEffect(() => {
        (window as { [key: string]: any }).populateMyColorsRandom = (arrayColors: any) => {

            if (!Array.isArray(arrayColors)) return;

            const colors = arrayColors.map((hex) => {
                const [r, g, b] = colorToRgb(hex);
                return { hex, r, g, b };
            }) as any;

            setMyColors(colors);
        };

        return () => {
            delete (window as { [key: string]: any }).populateMyColorsRandom;
        };
    }, []);

    function colorToRgb(color: any) {
        const tempElement = document.createElement('div');
        tempElement.style.color = color;
        document.body.appendChild(tempElement);

        const rgb = getComputedStyle(tempElement).color;
        document.body.removeChild(tempElement);

        const str = rgb.match(/\d+/g) as any;

        return str.map(Number);
    }

    return (
        <Card className="w-full border-none shadow-lg bg-card/85 backdrop-blur-sm h-full rounded-none">
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-foreground/80">
                    <Palette className="h-4 w-4" />
                    <span className="lang" data-en="COLOR OPTIONS" data-pt="OPÇÕES DE CORES" data-es="OPCIONES DE COLOR">
                        {__('COLOR OPTIONS')}
                    </span>
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                <div id="colorsButtons" className="flex flex-wrap gap-2">
                    <Button
                        id="addcolorsvg"
                        variant="outline"
                        size="sm"
                        className="lang gap-2 bg-secondary transition-all hover:bg-primary hover:text-primary-foreground"
                        data-en="Update colors"
                        data-pt="Atualizar cores"
                        data-es="Actualizar colores"
                    >
                        <RefreshCw className="h-4 w-4" />
                        {__('Update colors')}
                    </Button>
                    <Button
                        id="random-colors"
                        variant="default"
                        size="sm"
                        className="lang gap-2 transition-all bg-secondary text-primary hover:text-background"
                        data-en="Random Colors"
                        data-pt="Cores Aleatórias"
                        data-es="Colores aleatorios"
                    >
                        <Shuffle className="h-4 w-4" />
                        {__('Random Colors')}
                    </Button>
                </div>

                <div className="space-y-4">
                    <span className='!text-[14px]'>Cores Presentes no Canvas:</span>
                </div>

                <div id="colorsPanel" className="grid grid-cols-5 min-h-[60px] rounded-lg border border-dashed border-muted-foreground/25 bg-muted/30 p-3">
                </div>

                <div className="space-y-4">
                    <span className='!text-[14px]'>Tabela de Cores:</span>
                </div>

                <div id="myColorsPanel" className="min-h-[60px] rounded-lg border border-dashed border-muted-foreground/25 bg-muted/30 p-3">
                    <div id="my-colors-svg-random" className="grid grid-cols-5 gap-2 justify-center max-h-[300px] overflow-y-auto">
                        {myColors.map((color: any, index) => (
                            <div
                                key={index}
                                className="colorNewRandom w-10 h-10 rounded cursor-pointer border"
                                style={{ backgroundColor: color.hex }}
                                data-r={color.r}
                                data-g={color.g}
                                data-b={color.b}
                            />
                        ))}
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export default ColorRandom
